import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/*search*/
import searchIndex from "views/searchIndex";
import defaultView from "views/searchtable/defaultView";
import mainSearch from "views/searchtable/mainSearch";
import resources from "views/searchtable/resources"; //学习资源
import electiveLib from "views/searchtable/electiveLib"; //选修库
import learnPlan from "views/searchtable/learnPlan"; //培训计划
import learnProject from "views/searchtable/learnProject"; //学习项目
import knowledges from "views/searchtable/knowledges"; //知识汇
import electiveResources from "views/searchtable/electiveResources"; //选修库学习资源
import electiveLearnPlan from "views/searchtable/electiveLearnPlan"; //选修库培训计划

export default [
  {
    path: "/searchIndex",
    name: "searchIndex",
    component: searchIndex,
    redirect: "searchIndex/default",
    meta: { title: "搜索", title_en: "Search" },
    children: [
      {
        path: "mainSearch",
        name: "mainSearch",
        component: mainSearch,
        meta: { title: "搜索", title_en: "Search" },
        children: [
          {
            path: "resources",
            name: "resources",
            component: resources,
            meta: { title: "搜索", title_en: "Search" },
          },
          {
            path: "elective",
            name: "elective",
            component: electiveLib,
            redirect: "elective/eleresources",
            meta: { title: "搜索", title_en: "Search" },
            children: [
              {
                path: "eleplan",
                name: "eleplan",
                component: electiveLearnPlan,
                meta: { title: "搜索", title_en: "Search" },
              },
              {
                path: "eleresources",
                name: "eleresources",
                component: electiveResources,
                meta: { title: "搜索", title_en: "Search" },
              },
            ],
          },
          {
            path: "knowledges",
            name: "knowledges",
            component: knowledges,
            meta: { title: "搜索", title_en: "Search" },
          },
          {
            path: "plan",
            name: "plan",
            component: learnPlan,
            meta: { title: "搜索", title_en: "Search" },
          },
          {
            path: "project",
            name: "project",
            component: learnProject,
            meta: { title: "搜索", title_en: "Search" },
          },
        ],
      },
      {
        path: "default",
        name: "default",
        component: defaultView,
        meta: { title: "搜索", title_en: "Search" },
      },
    ],
  },
];
